import FormItem from "@components/formItem";
import { getUser } from "@utils";
import React from "react";
import { connect } from "react-redux";
import PaymentSelect from "../../../../../components/paymentSelect/index.jsx";
import { Box, BoxTitle, Content, ContentTitle } from "../baseItems";
import Base from "./base";

class Odendibil extends Base {
	componentDidMount() {
		const { selectedDeposit } = this.props;
		this.setState({ selectedCurrency: selectedDeposit.currencies[0].currency });
		if (selectedDeposit.name === "PEP ODENDIBIL") {
			return;
		}
		let body = {
			paymentType: selectedDeposit.paymentMethod,
			sessionId: getUser().sessionId,
		};
		this.props.externalFunc.getBankList(body);
	}

	onSelectBankLocal(e) {
		this.setState(
			{
				selectedBank: e.value,
			},
			() => {
				this.checkRequiredFields(false);
			}
		);
	}

	getStep1(translate) {
		const { selectedDeposit, banks } = this.props;
		const { selectedBank } = this.state;
		let bankOptions = [{ value: 0, label: translate("PLEASE_SELECT") }];
		banks.map((item, index) => {
			let newOpt = { value: index, label: item.name };
			bankOptions.push(newOpt);
		});
		let bank = selectedBank ? bankOptions.find((o) => o.value === selectedBank).value : 0;
		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				{selectedDeposit.name !== "PEP ODENDIBIL" && (
					<FormItem onRegister={() => this.registerField({ name: "selectedBank" })}>
						<Box>
							<BoxTitle>{translate("SELECT_BANK")}</BoxTitle>
							<PaymentSelect
								options={bankOptions}
								value={bank}
								onLoad={() => this.registerField({ name: "selectedBank" })}
								handleSelect={this.onSelectBankLocal.bind(this)}
							/>
						</Box>
					</FormItem>
				)}
				{this.getStakeField()}
				{this.renderMinMax()}
			</Content>
		);
	}

	makeExternalPayment(newStep) {
		const { stake, selectedBank } = this.state;
		const { banks, selectedDeposit } = this.props;
		let bank = banks.find((item) => item.name == selectedBank);
		if (selectedDeposit.name === "ODENDIBIL-PEP") {
			this.props.externalFunc.depositPep(
				{
					amount: stake,
					sessionId: getUser().sessionId,
				},
				(data) => {
					this.setState({
						externalUrl: data.result.url,
						currentStep: newStep,
					});
				}
			);
		} else if (
			selectedDeposit.name === "ODENDIBIL-CEPBANK" ||
			selectedDeposit.name === "ODENDIBIL-QR"
		) {
			this.props.externalFunc.depositCepbankQr(
				{
					amount: stake,
					sessionId: getUser().sessionId,
					bankId: bank.bank_id,
					paymentType: selectedDeposit.paymentMethod,
				},
				(data) => {
					this.setState({
						externalUrl: data.result.url,
						currentStep: newStep,
					});
				}
			);
		}
	}

	makeExternalPaymentWithBonus(newStep, bonusId) {
		const { stake, selectedBank } = this.state;
		const { banks, selectedDeposit } = this.props;
		let bank = banks.find((item) => item.name == selectedBank);
		if (selectedDeposit.name === "ODENDIBIL-PEP") {
			this.props.externalFunc.depositPep(
				{
					amount: stake,
					sessionId: getUser().sessionId,
					claimsBonus: true,
					bonusId: bonusId,
				},
				(data) => {
					this.setState({
						externalUrl: data.result.url,
						currentStep: newStep,
					});
				}
			);
		} else if (
			selectedDeposit.name === "ODENDIBIL-CEPBANK" ||
			selectedDeposit.name === "ODENDIBIL-QR"
		) {
			this.props.externalFunc.depositCepbankQr(
				{
					amount: stake,
					sessionId: getUser().sessionId,
					bankId: bank.bank_id,
					paymentType: selectedDeposit.paymentMethod,
					claimsBonus: true,
					bonusId: bonusId,
				},
				(data) => {
					this.setState({
						externalUrl: data.result.url,
						currentStep: newStep,
					});
				}
			);
		}
	}
}

const mapStateToProps = (state) => ({
	banks: state.deposit.odendibilBanks,
});

export default connect(mapStateToProps, null)(Odendibil);
